const getters = {
  sysToken(state) {
    return state.sysToken
  },
  userInfo(state) {
    return state.userInfo
  },
  companyInfo(state) {
    return state.companyInfo
  },
  originCompanyInfo(state) {
    return state.originCompanyInfo
  },
  companyId(state) {
    return state.userInfo.companyId
  },
  isGSLogin(state) {
    return state.isGSLogin
  },
  originNavList(state) {
    return state.originNavList
  },
  navList(state) {
    return state.navList
  },
  brandList(state) {
    return state.brandList
  },
  shopList(state) {
    return state.shopList
  },
  brandInfo(state) {
    return state.brandInfo
  },
  shopInfo(state) {
    return state.shopInfo
  },
  hierarchyType(state) {
    return state.userInfo.hierarchyType
  },
  roleInfo(state) {
    return state.roleInfo
  },
  allShopList(state) {
    return state.allShopList
  },
  backMenuConfig(state) {
    return state.backMenuConfig
  },
  backPageConfig(state) {
    return state.backPageConfig
  },
  frontPageConfig(state) {
    return state.frontPageConfig
  },
  businessMpPageConfig(state) {
    return state.businessMpPageConfig
  },
  isHaveAgentAuth(state) {
    return state.originCompanyInfo.isHaveAgentAuth
  },
  agentCompanyList(state) {
    return state.agentCompanyList
  },
  userShopId(state) {
    return state.userInfo.shopId
  },
  isOpenGxms(state) {
    let isOpenGxms = false
    let businessMode = state.companyInfo.businessMode || ''
    if (businessMode !== '') {
      businessMode = businessMode.split(',')
      isOpenGxms = businessMode.some(info => info === '6')
    }
    return isOpenGxms
  },
  isOpenScms(state) {
    let isOpenScms = false
    let businessMode = state.companyInfo.businessMode || ''
    if (businessMode !== '') {
      businessMode = businessMode.split(',')
      isOpenScms = businessMode.some(info => info === '7')
    }
    return isOpenScms
  },
  isOpenBwcMode(state) {
    let isOpenBwc = false
    let businessMode = state.companyInfo.businessMode || ''
    if (businessMode !== '') {
      businessMode = businessMode.split(',')
      isOpenBwc = businessMode.some(info => info === '8')
    }
    return isOpenBwc
  },
  groupInfo(state) {
    return state.groupInfo || { payType: '1' }
  },
  groupPayType(state) {
    return state.groupInfo.payType || '1'
  },
  // 公司出款方式(4:微信；5：支付宝；''：未配置)
  companyWithdrawalWay(state) {
    let list = state.companyAccountList
    if (list.some(info => info.accountChannel === '4')) {
      return '4'
    } else if (list.some(info => info.accountChannel === '5')) {
      return '5'
    } else {
      return ''
    }
  },
  // 公司收款账号（1：微信；3汇付天下；''：未配置）
  companyInAccountWay(state) {
    let list = state.companyAccountList
    if (list.some(info => info.accountChannel === '1')) {
      return '1'
    } else if (list.some(info => info.accountChannel === '3')) {
      return '3'
    } else {
      return ''
    }
  },
  // 高校门店其他费用
  customChargeItemList(state) {
    return state.customChargeItemList
  },
  //  原始代码
  // sidebar: state => state.app.sidebar,
  // device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name
}
export default getters
